import { Badge, Flex, Td, Text, Tr } from '@chakra-ui/react'
import { controlList } from './storage'
import List from '../../lib/list'
import TypeIdentificationDocument, {
    TypeIdentificationDocumentByCode
} from '../../utilities/type_identification_document'
import dayjs from 'dayjs'
import ModalView from './ModalContents/ModalView'
import TableActions from './TableActions'
import useStorage from '../../hooks/useStorage'
import Client from '../../models/client'
import { getColorPayment } from '../../utilities/colorPayment'
import { OrderPaymentData } from './types'

export default function TableSales() {
    const { cashboxes, business_variables } = useStorage()

    const print_sale_note = business_variables.find(
        v => v.code === '001'
    )?.value
    const generate_electronic_receipts = business_variables.find(
        v => v.code === '002'
    )?.value

    function getFullNameClient(client: Client) {
        const fullNumber = `${
            TypeIdentificationDocument[client.type_identification_document_id]
        }: ${client.number}`
        if (client.type_identification_document_id === 2) {
            return {
                fullName: client.business_name,
                fullNumber
            }
        }
        return {
            fullName: `${client.firstname} ${client.lastname}`,
            fullNumber
        }
    }

    function getUserCashbox(cashbox_id: number) {
        const cashbox = cashboxes.find(c => c.id === cashbox_id)

        return cashbox?.user
            ? `${cashbox.user.firstname} ${cashbox.user.lastname}`
            : cashbox?.name
    }

    function getTip(_data: OrderPaymentData['orderPaymentDetails']) {
        const opd = _data.find(_opd => _opd.type_payment_id === 4)
        return opd ? `S/${opd.amount.toFixed(2)}` : '-'
    }

    return (
        <List
            control={controlList}
            fullWidth
            tbody={orderPayment => (
                <Tr key={orderPayment.id}>
                    <Td>
                        <ModalView
                            orderPaymentId={orderPayment.id}
                            element={click => (
                                <Text
                                    textDecoration="underline"
                                    cursor="pointer"
                                    onClick={click}
                                    fontFamily="Poppins"
                                    color="blue.400"
                                >
                                    {dayjs(orderPayment.created_at).format(
                                        'DD/MM/YYYY hh:mm a'
                                    )}
                                </Text>
                            )}
                        />
                    </Td>
                    <Td>
                        {getUserCashbox(orderPayment.cashbox_user.cashbox_id)}
                    </Td>
                    <Td>
                        {orderPayment.sunat_voucher
                            ? orderPayment.sunat_voucher.code
                            : orderPayment.code}
                    </Td>
                    <Td>
                        <Text>
                            {orderPayment.sunat_voucher
                                ? orderPayment.sunat_voucher.client_name
                                : getFullNameClient(orderPayment.client)
                                      .fullName}
                        </Text>
                        <Text whiteSpace="nowrap" fontSize="xs">
                            {orderPayment.sunat_voucher
                                ? `${
                                      TypeIdentificationDocumentByCode[
                                          parseInt(
                                              orderPayment.sunat_voucher
                                                  .client_type_document
                                          )
                                      ]
                                  }: ${
                                      orderPayment.sunat_voucher
                                          .client_number_document
                                  }`
                                : getFullNameClient(orderPayment.client)
                                      .fullNumber}
                        </Text>
                    </Td>
                    <Td whiteSpace="nowrap">
                        S/ {orderPayment.total_final.toFixed(2)}
                    </Td>
                    <Td>
                        <Flex gap={1} flexWrap="wrap">
                            {orderPayment.orderPaymentDetails
                                .filter(opd => opd.type_payment_id !== 4)
                                .map(opd => {
                                    const name =
                                        opd?.sub_payment_type_data?.name ||
                                        opd.order_payment_detail.name

                                    return (
                                        <Badge
                                            key={opd.id}
                                            variant="subtle"
                                            colorScheme={getColorPayment(name)}
                                            textTransform="capitalize"
                                        >
                                            {name}: S/
                                            {opd.amount.toFixed(2)}
                                        </Badge>
                                    )
                                })}
                        </Flex>
                    </Td>
                    <Td>{getTip(orderPayment.orderPaymentDetails)}</Td>
                    <Td>
                        {orderPayment.account_order.order.user.firstname}{' '}
                        {orderPayment.account_order.order.user.lastname}
                    </Td>
                    <Td>
                        {orderPayment.account_order.status === 2 ? (
                            <Badge bg="alo-blue" color="white">
                                Vigente
                            </Badge>
                        ) : (
                            <Badge bg="error" color="white">
                                Anulado
                            </Badge>
                        )}
                    </Td>
                    <Td>
                        <TableActions
                            orderPayment={orderPayment}
                            print_sale_note={print_sale_note}
                            generate_electronic_receipts={
                                generate_electronic_receipts
                            }
                        />
                    </Td>
                </Tr>
            )}
        />
    )
}
